export function Logo({ size = 32, withWordmark = true }) {
    return (
        <div className="flex items-center gap-2.5">
            <div className="logo-sphere" style={{ width: size, height: size }} />
            {withWordmark && (
                <span
                    className="font-extrabold text-[1.05rem] tracking-tight"
                    style={{
                        fontFamily: "Cabinet Grotesk, sans-serif",
                        background: "linear-gradient(180deg, #1D1D1F 0%, #4b4b52 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                    }}
                >
                    DomainMigInt
                </span>
            )}
        </div>
    );
}
